import React from 'react';
import { Box, Typography } from '@mui/material';

const Kbd: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography
    component="kbd"
    variant="caption"
    sx={{
      px: 0.75,
      py: 0.25,
      mx: 0.25,
      borderRadius: 0.5,
      border: '1px solid',
      borderColor: 'divider',
      backgroundColor: 'action.hover',
      fontFamily: 'inherit',
      fontSize: '0.7rem',
      lineHeight: 1.4,
    }}
  >
    {children}
  </Typography>
);

const CommandPaletteFooter: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 2,
        py: 1,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Kbd>↑</Kbd>
        <Kbd>↓</Kbd>
        <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
          navigate
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Kbd>Enter</Kbd>
        <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
          select
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Kbd>Esc</Kbd>
        <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
          close
        </Typography>
      </Box>
    </Box>
  );
};

export default CommandPaletteFooter;
